{
  "equivalentMeasures": [
    {
      "measureId": "QPP-66",
      "cmsEcqmId": "CMS-146"
    },
    {
      "measureId": "QPP-128",
      "cmsEcqmId": "CMS-69"
    },
    {
      "measureId": "QPP-130",
      "cmsEcqmId": "CMS-68"
    },
    {
      "measureId": "QPP-226",
      "cmsEcqmId": "CMS-138"
    },
    {
      "measureId": "QPP-236",
      "cmsEcqmId": "CMS-165"
    },
    {
      "measureId": "QPP-238",
      "cmsEcqmId": "CMS-156"
    },
    {
      "measureId": "QPP-317",
      "cmsEcqmId": "CMS-22"
    },
    {
      "measureId": "QPP-318",
      "cmsEcqmId": "CMS-139"
    },
    {
      "measureId": "QPP-374",
      "cmsEcqmId": "CMS-50"
    }
  ]
}
